module.exports = __webpack_public_path__ + "img/logo-sd-ls.6939c97c.png";